import axios from 'axios';

import { ParamsBodyFormFaleConosco } from 'utils/typeServices';

export const PostFormFaleConosco = async ({ body }: { body: ParamsBodyFormFaleConosco }) => {
    try {
        const data = await axios.post<string>('https://apibackend-prd.ituran.com.br/v1/email/form-fale-conosco', body, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
